import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@linaria/core'
import { colors, Paragraph, Row, WhiteTheme } from '@fs/zion-ui'

const positionCss = css`
  width: 100%;
  position: absolute;
  padding: 6px;
  bottom: 0;
`
const textBackgroundCss = css`
  background: ${colors.gray80};
  padding: 6px 8px;
  border-radius: 6px;
`

export default function MediaFooter({ Icon, text, alignX, bold }) {
  return (
    <div className={positionCss} data-testid="media-footer">
      <Row alignX={alignX} data-testid="media-footer-row">
        <WhiteTheme className={textBackgroundCss}>
          <Row alignY="bottom" gutters="nano">
            {Icon && <Icon data-testid="media-footer-icon" />}
            {text && <Paragraph size="sm">{bold ? <strong>{text}</strong> : text}</Paragraph>}
          </Row>
        </WhiteTheme>
      </Row>
    </div>
  )
}

MediaFooter.propTypes = {
  /** Icon to be shown next to footer text */
  Icon: PropTypes.elementType,

  /** Text to be displayed */
  text: PropTypes.string.isRequired,

  /** Align footer content horizontally */
  alignX: PropTypes.oneOf(['start', 'end']),

  /** Whether or not the text is bolded */
  bold: PropTypes.bool,
}
